import PropTypes from 'prop-types';
import { useLayoutEffect, useRef } from 'react';

import { Logout } from '»components/Auth';

import {
  DividerStyled,
  GenericMenuItemsStyled,
} from './GenericMenuItems.styles';
import { SettingsMenuItem } from './SettingsMenuItem/SettingsMenuItem';

export const GenericMenuItemsWrapper = ({ setElMenuHeight }) => {
  const genericMenuRef = useRef(null);

  useLayoutEffect(() => {
    setElMenuHeight([
      {
        elName: 'bottomButtonsSection',
        elHeight: genericMenuRef.current.offsetHeight,
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GenericMenuItemsStyled ref={genericMenuRef}>
      <DividerStyled />
      <SettingsMenuItem />
      <Logout />
    </GenericMenuItemsStyled>
  );
};

GenericMenuItemsWrapper.propTypes = {
  setElMenuHeight: PropTypes.func.isRequired,
};
